import axiosClient from "./axiosClient";

const staffApi = {
  async login({ username, password }) {
    const response = await axiosClient.post("/token/", { username, password });
    return response.data;
  },

  async logout(refreshToken) {
    return axiosClient.post("/logout/", { refresh_token: refreshToken });
  },
};

export default staffApi;
